import { useContrastMutation } from '../../hooks/use-contrast-mutation'
import { UseMutationOptions } from 'react-query'
import {
  updateProtectRule,
  UpdateProtectRuleArgs
} from '../../api/mutations/protect-rules/update-protect-rule'
import { HTTPError } from '../../api/fetch/decorate-fetch'

interface Response {
  readonly success: boolean
  readonly messages: string[]
}

export function useUpdateProtectRule(
  options?: UseMutationOptions<Response, HTTPError, UpdateProtectRuleArgs>
) {
  return useContrastMutation<Response, HTTPError, UpdateProtectRuleArgs>(
    updateProtectRule,
    options
  )
}
